// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"9b4a37e6","389":"74a506c9","732":"5fa08dcd","977":"85cca77c"}[chunkId] + ".chunk.js";
};